import { useRef } from 'react'
import If from '@mobi/components/If'
import Header from 'components/Header'
import Text from 'components/Text'
import LandingLayout from '../../layouts/LandingLayout'
import useMediaQuery from 'hooks/useMediaQuery'
import Recaptcha from 'react-google-invisible-recaptcha'
import { CAPTCHA_KEY, RENEG_CAPTCHA_KEY } from 'gatsby-env-variables'
import './LandingRegister.scss'
import WhatsAppButton from 'components/WhatsAppButton'
import DiscountBanner from './DiscountBanner'
import LandingHeroForm from '../Landing/components/LandingHero/Form'

const LandingRegister = ({ location }) => {
  const isDesktop = useMediaQuery('notMobile')

  const refRecaptchaReneg = useRef(null)

  return (
    <LandingLayout>
      <Recaptcha sitekey={CAPTCHA_KEY} />
      <Recaptcha sitekey={RENEG_CAPTCHA_KEY} ref={refRecaptchaReneg} />
      <Header />

      <DiscountBanner />

      <WhatsAppButton dataUnique="7270860c-eded-460e-b7f6-b63bfec2800b" />
      <div className="landing-register-container">
        <div className="landing-register-content">
          <If
            condition={isDesktop}
            renderIf={
              <Text h1 size={4} className="top-text">
                {location?.state?.title ||
                  `Para prosseguir precisamos das informações abaixo`}
              </Text>
            }
            renderElse={
              <If
                condition={location?.state?.title}
                renderIf={
                  <Text h1 size={4} className="top-text">
                    {location?.state?.title}
                  </Text>
                }
                renderElse={
                  <div className="mobile-top-texts">
                    <Text h1 size={6}>
                      Preencha seus dados
                    </Text>
                    <Text h2 size={7}>
                      para calcularmos a melhor oferta
                    </Text>
                  </div>
                }
              />
            }
          />
          <LandingHeroForm
            location={location}
            refRecaptchaReneg={refRecaptchaReneg}
          />
        </div>
      </div>
    </LandingLayout>
  )
}

export default LandingRegister
